import * as React from "react";

export default class HeaderButton extends React.Component {
  render() {
    return (
      <div
        className={
          "header__button " + (this.props.classes ? this.props.classes : "")
        }
      >
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/HeaderButton.js